module.exports = __webpack_public_path__ + "static/media/(V)-Artesanato-11.e8ed7dc5.jpg";